// Load the global Modern skin styles for the standalone main app. This module
// is only referenced by standalone HTML, so the shared `application.ts`
// bootstrap stays untouched for the regular (server-rendered) build. Vite
// compiles the SCSS and injects the stylesheet link into <head>.
import 'flavours/glitch/styles/modern.scss';

if (import.meta.env.VITE_EXPERIMENTAL_UI === 'true') {
  document.documentElement.dataset.redesign = 'true';
}

const INITIAL_STATE_VERSION = 2;

interface StoredState {
  version: number;
  data: unknown;
  timestamp: number;
}

function injectInitialState() {
  const stored = localStorage.getItem('initial_state');

  if (!stored) {
    redirectToAuth();
    return;
  }

  try {
    const parsed = JSON.parse(stored) as StoredState;

    if (parsed.version !== INITIAL_STATE_VERSION) {
      redirectToAuth();
      return;
    }

    const scriptElement = document.createElement('script');
    scriptElement.id = 'initial-state';
    scriptElement.type = 'application/json';
    scriptElement.textContent = JSON.stringify(parsed.data);
    document.head.appendChild(scriptElement);
  } catch (error) {
    console.error('Failed to inject initial state:', error);
    window.location.href = '/login';
  }
}

function redirectToAuth() {
  const domain = localStorage.getItem('domain');
  const accessToken = localStorage.getItem('access_token');

  if (domain && accessToken) {
    window.location.href = '/prepare';
  } else {
    window.location.href = '/login';
  }
}

injectInitialState();
